import React from 'react';
import { SvgIcon } from '@material-ui/core';

const FileIconImage = props => {
  return(
    <SvgIcon viewBox="0 0 250 250" {...props}>
      <g id="video-file-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M46.875,0 C38.28125,0 31.25,7.03125 31.25,15.625 L31.25,234.375 C31.25,242.96875 38.28125,250 46.875,250 L203.125,250 C211.71875,250 218.75,242.96875 218.75,234.375 L218.75,62.5 L156.25,0 L46.875,0 Z" id="Path" fill="#E2E5E7" fillRule="nonzero"></path>
        <path d="M171.875,62.5 L218.75,62.5 L156.25,0 L156.25,46.875 C156.25,55.46875 163.28125,62.5 171.875,62.5 Z" id="Path" fill="#B0B7BD" fillRule="nonzero"></path>
        <polygon id="Path" fill="#CAD1D8" fillRule="nonzero" points="218.75 109.375 171.875 62.5 218.75 62.5"></polygon>
        <rect id="Rectangle" stroke="#264F73" fill="#264F73" x="31" y="93" width="188" height="103"></rect>
        <path d="M209.6,197.125 L31,197.125 L31,203.625 L209.6,203.625 C214.77,203.625 219,200.7 219,197.125 L219,190.625 C219,194.2 214.77,197.125 209.6,197.125 Z" id="Path" fill="#CAD1D8" fillRule="nonzero"></path>
        <path d="M132,0 C148.333333,0 156.5,0 156.5,0 C156.5,0 177.333333,20.8333333 219,62.5 L219,250 L132,250 L132,0 Z" id="Rectangle" fillOpacity="0.1" fill="#264F73"></path>
        <polygon id="Triangle" fill="#E2E5E7" transform="translate(132.500000, 143.250000) rotate(-270.000000) translate(-132.500000, -143.250000) " points="132.5 119 166 167.5 99 167.5"></polygon>
      </g>
    </SvgIcon>
  );
};

export default FileIconImage;
